var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('carousel',{attrs:{"per-page":1,"navigation-enabled":true,"pagination-enabled":false},on:{"pageChange":_vm.changeAvisSlide}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }